import { OrganizationFacilitiesIncidentCountQuery } from '@/graphql/generated/operations'
import { GLOBAL_PAGE_LOAD_ANALYTIC_NAME } from '@/pages/global'
import { trackEvent } from '@/utils/analytics'

export const trackOrganisationInfo = (
  numNormalFacilities: number,
  facilitiesIncidentCountData: OrganizationFacilitiesIncidentCountQuery
) => {
  // Total incidents for all the facilities
  const numberOfIncidents =
    facilitiesIncidentCountData?.activeIncidentCountsForAffectedFacilities?.edges?.reduce(
      (n, { node }) => n + node.incidents?.totalCount,
      0
    )

  trackEvent(GLOBAL_PAGE_LOAD_ANALYTIC_NAME, {
    number_of_incidents: numberOfIncidents,
    number_of_facilities: numNormalFacilities,
  })
}
